import pickBy from "lodash/pickBy";
import identity from "lodash/identity";

export const highlights = [{ text: /{:{(.*?)}:}/g }];

export function clean(object: any) {
  return pickBy(object, identity);
}
